import { Row } from "./Row";
interface IProsp {
  isShow: boolean;
  onToggle: () => void;
}

export const HowWeSecurePersonalInformation = ({ onToggle, isShow }: IProsp) => {
  return (
    <Row
      title="How We Secure Personal Information"
      onToggle={onToggle}
      isShow={isShow}
    >
      <div>
        Medcursor has an information security program to implement reasonable and
        appropriate industry-standard security controls to protect personal
        information in its possession. Medcursor also requires its service
        providers to implement controls that are at least as stringent as the
        ones Medcursor itself uses, consistent with this policy. Medcursor's
        administrative, physical, and technical safeguards:
        <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
          <li>
            Provide assurances of the integrity and confidentiality of personal
            information covered by this policy;
          </li>
          <li>
            Protect against reasonably anticipated threats or hazards to the
            security or integrity of personal information, and unauthorized uses
            or disclosures of such personal information; and
          </li>
          <li>
            Facilitate compliance with legal frameworks of requirements under
            applicable data protection laws.
          </li>
        </ul>
        <div className="mt-4">
          One example of a security safeguard we use is encryption.
          Specifically, our mobile applications use encrypted communications
          when they obtain your personal information and our payment service
          receives your payment information to complete orders and obtain
          payment for products you purchase using our website.
        </div>
      </div>
    </Row>
  );
};
